export default __webpack_public_path__ + "static/media/MysteryBox_159x150.de69c65f.png";